module.exports = __webpack_public_path__ + "img/Chasseur.e5f4cb92.png";